import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { makeStyles } from '@mui/styles';

// import './style.scss';

const useStyle = makeStyles({
  root: {
    flexGrow: 1,
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  title: {
    left: '0px',
    position: 'absolute',
    minInlineSize: 'fit-content',
  },
  tabs: {
    maxWidth: '75%',
    zIndex: 90,
  },
  tabsWithoutTitle: {
    zIndex: 90,
  },
  tab: {
    minWidth: '140px',
    maxWidth: 'inherit',
    fontSize: '1.4rem',
    textTransform: 'none',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 700,
    color: '#5a6a7a',
    padding: '14px 24px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(117, 202, 227, 0.1)',
      color: '#1487ae',
    },
    '&.Mui-selected': {
      color: '#1487ae',
      fontWeight: 700,
    },
  },
  tabWhite: {
    minWidth: '140px',
    maxWidth: 'inherit',
    fontSize: '1.4rem',
    textTransform: 'none',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 700,
    color: '#5a6a7a',
    padding: '14px 24px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(117, 202, 227, 0.1)',
      color: '#1487ae',
    },
    '&.Mui-selected': {
      color: '#1487ae',
      fontWeight: 700,
    },
  },
  closeButton: {
    position: 'absolute',
    top: '3px',
    right: 0
  }
});

export default function TabsContainer(props) {
  const classes = useStyle();

  const getDefaultTab = () => {
    if (props.defaultTab !== undefined && props.defaultTab < props.tabs.length) {
      return props.defaultTab;
    }
    return 0;
  };

  const [selectedTab, setSelectedTab] = React.useState(getDefaultTab);

  React.useLayoutEffect(() => {
    if (props.title === 'New Couple') {
      // debugger;
    }
    setSelectedTab(getDefaultTab());
  }, [props.tabs.length, props.defaultTab]);

  // eslint-disable-next-line no-unused-vars
  const handleTabChange = (_event, newValue) => {
    if (props.onTabChange) {
      props.onTabChange(selectedTab, newValue);
    }

    setSelectedTab(newValue);
  };

  if (props.title === 'New Couple') {
    // debugger;
  }

  const justify = props.justifyCenter ? 'center' : 'flex-end';

  const tabBarStyle = {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #d0e8ef',
    padding: '0 16px',
  };

  const tabIndicatorStyle = {
    backgroundColor: '#1487ae',
    height: '3px',
    borderRadius: '3px 3px 0 0',
  };

  return (
    <Paper
      elevation={0}
      className={classes.root}
      sx={{ backgroundColor: 'transparent' }}
    >

      <Box display="flex" justifyContent={justify} style={{ ...tabBarStyle, ...(props.tabsContainerStyle || {}) }}>

        { props.title &&
          <Typography className={classes.title} variant='h2'>{props.title}</Typography>
        }
        <Tabs
          className={(props.title) ? classes.tabs : classes.tabsWithoutTitle}
          value={(props.tabs.length > selectedTab) ? selectedTab : 0}
          onChange={handleTabChange}
          aria-label={'tabs_container'}
          variant='scrollable'
          style={props.tabsButtonsStyle || null}
          TabIndicatorProps={{
            style: tabIndicatorStyle
          }}
        >

          {
            props.tabs.map((tab, index) => (
              <Tab
                classes={{root: props.whiteTabs ? classes.tabWhite : classes.tab}}
                key={index}
                value={index}
                label={tab.label}
                sx={{ fontWeight: 700, '&.Mui-selected': { fontWeight: 700 } }}
              />
            ))
          }
        </Tabs>
        {props.handleClose &&
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        }
      </Box>

      {
        props.tabs.map((tab, index) => (
          <div
            key={index}
            role="tabpanel"
            hidden={selectedTab !== index}
            id={`app-tabpanel-${index}`}
            aria-labelledby={`app-tab-${index}`}
            style={(tab.style) ? { ...tab.style, backgroundColor: '#f5f9fa' } : { maxHeight: '355px', overflowY: 'auto' }}
          >
            { selectedTab === index && (
              <Box style={{maxHeight: 'inherit', padding: '16px'}}>
                {tab.component}
              </Box>
            )}
          </div>
        ))
      }

    </Paper>
  );
}

TabsContainer.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  defaultTab: PropTypes.number,
  handleClose: PropTypes.func,
  justifyCenter: PropTypes.bool,
  onTabChange: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    component: PropTypes.node.isRequired,
    style: PropTypes.object,
  })).isRequired,
  tabsButtonsStyle: PropTypes.object,
  tabsContainerStyle: PropTypes.object,
  title: PropTypes.string,
};
